import React from "react";

/**
 * KibliApp Logo — usa la imagen oficial del logotipo.
 * - `iconOnly`: muestra sólo el escudo con la cara del niño.
 * - Por defecto muestra el escudo + texto "KibliApp" (texto tipográfico para
 *   mantener nitidez a cualquier tamaño).
 */
export default function KibliLogo({ size = 48, withText = true, iconOnly = false }) {
  const iconSrc = `${process.env.PUBLIC_URL || ""}/kibli-icon.jpg`;
  const fullSrc = `${process.env.PUBLIC_URL || ""}/kibli-logo.jpg`;

  // If user wants the literal full logo image with text baked in
  if (iconOnly === "image") {
    return (
      <img src={fullSrc} alt="KibliApp" style={{ height: size }} data-testid="kibli-logo" className="select-none" />
    );
  }

  return (
    <div className="inline-flex items-center gap-2 select-none" data-testid="kibli-logo" translate="no">
      <img
        src={iconSrc}
        alt="KibliApp"
        width={size}
        height={size}
        className="object-contain notranslate"
        style={{ width: size, height: size }}
        draggable={false}
      />
      {withText && !iconOnly && (
        <div
          className="font-extrabold leading-none tracking-tight notranslate"
          translate="no"
          style={{ fontFamily: "Plus Jakarta Sans", fontSize: Math.max(18, size * 0.5) }}
        >
          <span style={{ color: "#1D4ED8" }}>K</span>
          <span style={{ position: "relative", color: "#1D4ED8", display: "inline-block" }}>
            i
            <span
              style={{
                position: "absolute",
                top: "-0.15em",
                left: "0.18em",
                width: "0.32em",
                height: "0.32em",
                borderRadius: "999px",
                background: "#FACC15",
                display: "inline-block",
              }}
            />
          </span>
          <span style={{ color: "#1D4ED8" }}>bli</span>
          <span style={{ color: "#22D3EE" }}>App</span>
        </div>
      )}
    </div>
  );
}
